import { render, staticRenderFns } from "./SwitchRole.vue?vue&type=template&id=7686f8d7"
import script from "./SwitchRole.vue?vue&type=script&lang=js"
export * from "./SwitchRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports